var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.combinedClass},_vm._l((_vm.errors),function(error,index){return _c('ul',{key:index,staticClass:"text-color-red text-medium"},[_c('li',[_vm._v(_vm._s(error))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }